export const DiagnosisConstants = {
  // Route Tokens
  defaultApi: 'Diagnosis',

//  APPLICATION: "application",
//  GROUP: "group",
//  OLDER_THAN: "olderThan",
//  ROLES: "roles",

  // Other constants
    UI: {
    ROOT_PATH: 'diagnosis',
  }

} as const;
